// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"541":"70f06fdb","570":"9114681a","702":"a23f7f09"}[chunkId] + ".chunk.css";
};